import ComingSoonPanel from './ComingSoonPanel';
import { Icon } from '../../components/ui/Icon';

export default function AutomationsPanel() {
  return (
    <ComingSoonPanel
      title="Automations"
      subtitle="Trigger actions when documents arrive, get classified, or expire."
      icon={Icon.zap}
      features={[
        { title: 'Auto-route by template',  desc: 'Send approved W-9s straight to your accountant.' },
        { title: 'Slack / Teams alerts',     desc: 'Ping a channel when high-priority docs land.' },
        { title: 'Conditional reminders',    desc: 'Custom escalation paths for overdue uploads.' },
        { title: 'Webhook triggers',          desc: 'Fire a webhook on any document state change.' },
      ]}
    />
  );
}
